import orderBy from 'lodash/orderBy';
import { useQuery } from 'react-query';

import { LibraryPanelTemplateRevisionSummary } from '@mpm-druid/types';
import api, { QueryConfig } from '@shared/api';

type GetPanelTemplateRevisionsResponse = {
  revisions: {
    id: string;
    templateId: string;
    createdBy: string;
    createdAt: string;
  }[];
};

export async function getPanelLibraryTemplateRevisions({
  signal,
  templateId
}: {
  signal?: AbortSignal;
  templateId: string;
}) {
  const { data } = await api.get<GetPanelTemplateRevisionsResponse>(
    `code-panels/mpm/templates/${templateId}/revisions`,
    { signal }
  );

  return orderBy(
    data.revisions.map(revision => ({
      created_at: revision.createdAt,
      created_by: revision.createdBy,
      id: revision.id
    })),
    'created_at'
  ).reverse();
}

export function usePanelLibraryTemplateRevisions(
  { templateId }: { templateId: string },
  config?: QueryConfig<LibraryPanelTemplateRevisionSummary[]>
) {
  return useQuery(
    ['panel-library-template-revisions', { templateId }],
    context => {
      return getPanelLibraryTemplateRevisions({
        templateId,
        signal: context.signal
      });
    },
    {
      retry: false,
      ...config,
      enabled: (config?.enabled ?? true) && !!templateId
    }
  );
}
